import { useCallback, useRef } from "react";

// Probably will use .waw files, but we'll keep this for now until we confirm the sounds.
export const useScannerSounds = () => {
  const audioContextRef = useRef<AudioContext | null>(null);

  const getAudioContext = useCallback(() => {
    if (!audioContextRef.current) {
      try {
        const AudioContext = window.AudioContext || (window as unknown as { webkitAudioContext: AudioContext }).webkitAudioContext;
        audioContextRef.current = new AudioContext();
      } catch (error) {
        console.warn("Web Audio API not supported", error);
        return null;
      }
    }
    return audioContextRef.current;
  }, []);

  const playBeep = useCallback(
    (frequency: number, duration: number) => {
      const context = getAudioContext();
      if (!context) return;

      try {
        const oscillator = context.createOscillator();
        const gainNode = context.createGain();

        oscillator.connect(gainNode);
        gainNode.connect(context.destination);

        oscillator.frequency.value = frequency;
        oscillator.type = "sine";

        const now = context.currentTime;
        gainNode.gain.setValueAtTime(0, now);
        gainNode.gain.linearRampToValueAtTime(0.3, now + 0.01);
        gainNode.gain.exponentialRampToValueAtTime(0.01, now + duration / 1000);

        oscillator.start(now);
        oscillator.stop(now + duration / 1000);
      } catch (error) {
        console.warn("Failed to play beep", error);
      }
    },
    [getAudioContext]
  );

  const playSuccess = useCallback(() => {
    playBeep(800, 150);
  }, [playBeep]);

  const playError = useCallback(() => {
    playBeep(400, 200);
  }, [playBeep]);

  return {
    playSuccess,
    playError,
  };
};
